import React from "react";
import { Link } from "react-router-dom";
import { useBrand } from "@/context/BrandContext";

export default function Logo({ to = "/", size = "md", withTag = true, tone = "light" }) {
  const { brand } = useBrand();
  const logoUrl = brand.logo_url || "";
  const centerShort = brand.center_short || "Local Benefits";

  // tone: 'light' = on white/light bg → white card, 'dark' = on dark bg → plain image
  const sizes = {
    sm: { tile: "h-10 w-10 p-1", img: "h-8 w-8" },
    md: { tile: "h-12 w-12 p-1.5", img: "h-9 w-9" },
    lg: { tile: "h-16 w-16 p-2", img: "h-12 w-12" },
  };
  const s = sizes[size] || sizes.md;

  const imgEl = logoUrl ? (
    <img src={logoUrl} alt={centerShort} className={`${s.img} object-contain`} />
  ) : (
    <div className={`${s.img} rounded-full bg-lime-500 flex items-center justify-center font-heading font-black text-navy-900 text-sm`}>
      {centerShort.charAt(0).toUpperCase()}
    </div>
  );

  const tile = tone === "light" ? (
    <div className={`rounded-2xl bg-white border border-navy-900/10 shadow-[0_4px_14px_-4px_rgba(11,18,32,0.15)] flex items-center justify-center ${s.tile}`}>
      {imgEl}
    </div>
  ) : imgEl;

  const inner = (
    <div className="flex items-center gap-2.5 group">
      {tile}
      {withTag && (
        <div className="leading-tight">
          <div className={`uppercase font-heading font-extrabold tracking-[0.08em] ${tone === "light" ? "text-navy-900" : "text-white"} ${size === "lg" ? "text-lg" : "text-base"}`}>
            Local Benefits
          </div>
          <div className={`text-[10px] uppercase tracking-[0.2em] ${tone === "light" ? "text-navy-900/50" : "text-white/50"} font-semibold`}>
            by <span dangerouslySetInnerHTML={{ __html: centerShort }} />
          </div>
        </div>
      )}
    </div>
  );
  return to ? <Link to={to} data-testid="logo-home-link">{inner}</Link> : inner;
}
